import { BookingSectionComponent } from './views/booking-section/booking-section.component';
import { SummaryComponent } from './views/summary/summary.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import * as Enums from './utils/enums';
import { CookiePolicyComponent } from './views/cookie-policy/cookie-policy.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: `/${Enums.AppRoutes.Booking}` },
  { path: Enums.AppRoutes.Booking, component: BookingSectionComponent },
  { path: Enums.AppRoutes.Summary, component: SummaryComponent },
  { path: Enums.AppRoutes.CookiePolicy, component: CookiePolicyComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
